export default __webpack_public_path__ + "static/media/jaw.1e48ca5a.png";